import { State } from "@meraki-internal/state";
import { AuthProvider } from "../HeaderAndNavigationBar";
import { APIClient } from "../support/api/APIClient";
import { IStatus } from "../IWebsiteDataV3";

type IClubId = string;

interface IClubAPIModel {
    foundationId: string;
    clubId: IClubId;
    name: string; // Spartan Robotics
    coordinate: [number, number]; // now we can put it on the map
    health: { // can show scorecard
        volunteerStatus?: IStatus;
        volunteerStatusMessage?: string;
        fundingStatus?: IStatus;
        fundingStatusMessage?: string;
        labStatus?: IStatus;
        labStatusMessage?: string;
    },
    // TODO:
    teams: any[]

    // for if they don't use use for their campaigns (Rapid Accelerator)
    donationLink?: string;
}

export interface IVolunteerMediaType {
    clubIds: string[];

    // TODO: don't return this
    foundationId: string;

    name: string;

    // don't return if false (for brevity)
    isClubAdmin: boolean;

    volunteerId: string;
    imagePath: string;
    titles: string[];
    email?:string;
}

export class ClubState extends State<Record<string, never>> {
    constructor(private parent: ClubsState, private clubId: string){
        super({});
    }
    getClub = () => this.parent.getClub(this.clubId);

    init = async () => {
        await this.refreshVolunteers()
    }

    refreshVolunteers = async () => {
        this.volunteers = await this.parent.apiClient.get((this.getClub() as any).links.volunteers);

        this.setState({ });
    }

    private volunteers: IVolunteerMediaType[] = [];

    getVolunteers = () => this.volunteers.sort((l, r) => l.name.localeCompare(r.name));

    addVolunteer = async (volunteer: Partial<IVolunteerMediaType>) => {
        // TODO: as any
        await this.parent.apiClient.post((this.getClub() as any).links.volunteers, volunteer);

        // TODO: return 200 to avoid this extra call

        await this.refreshVolunteers();
    }

    updateVolunteer = async (volunteer: IVolunteerMediaType) => {
        // TODO: as any
        await this.parent.apiClient.put((volunteer as any).links.self, volunteer);

        await this.refreshVolunteers();
    }

    deleteVolunteer = async (volunteer: IVolunteerMediaType) => {
        // TODO: as any
        await this.parent.apiClient.delete((volunteer as any).links.self);

        await this.refreshVolunteers();
    }
}

// what problem am I solving?
// I want an instance of this I am passing around
// ideally even simple able to get from context

export class ClubsState extends State<Record<string, never>> {
    static inject = () => [
        APIClient,
        AuthProvider
    ];
    constructor(
        public apiClient: APIClient,
        private authProvider: AuthProvider
    ){
        super({ });
    }

    // TODO: how
    init = async () => {
        if (this.authProvider.idToken){
            const entry = await this.apiClient.entry();
            const clubs = await this.apiClient.get(entry.links.clubs);

            // TODO: technically API Media type
            this.clubs = clubs;
            this.setState({ });
        }
    }

    private clubs: IClubAPIModel[] = [];
    private clubIdsToClubState: { [clubId: string]: ClubState } = {};

    // TODO: get this into the virtual dom, possibly with a container context
    getClubState = (clubId: string): ClubState => {
        if (!this.clubIdsToClubState[clubId]){
            this.clubIdsToClubState[clubId] = new ClubState(this, clubId);
            setTimeout(() => {
                this.clubIdsToClubState[clubId].subscribe(() => {
                    this.setState({ });
                });

                // TODO: error handling
                this.clubIdsToClubState[clubId].init();
            })
        }

        return this.clubIdsToClubState[clubId];
    }

    getAllClubStates = () => {
        const states: ClubState[] = [];

        for (const clubId of Object.keys(this.clubIdsToClubState)){
            states.push(this.clubIdsToClubState[clubId]);
        }

        return states;
    }

    getClub = (clubId: string) => {
        const club = this.maybeGetClub(clubId);
        if (!club){
            throw new Error(`club ${clubId} does not exist`);
        }
        return club;
    }

    maybeGetClub = (clubId: string) => {
        return this.clubs.find(c => c.clubId === clubId);
    }

    saveClubHealth = async (clubId: string, health: IClubAPIModel['health']) => {
        if (!this.apiClient){
            throw new Error('not authenticated');
        }
        const club = this.getClub(clubId);

        club.health = health;
        this.setState({ });

        // TODO: API media type has links
        await this.apiClient.put((club as any).links.self, club);
    }
}

// TODO: clicked back to home and I cannot scroll
// body.backdrop-no-scroll is being left on the dom by core.scss